import { RECAPTCHA_KEY, webServiceErrorHandler } from "@/constants/constant";
import FrontSonda from "@gc-npm/utils.monitoring.front-sonda";

export const getClientsIds = (context) => {
  const { clientIDs } = { ...context };
  const { ga: client_id, sessionId: session_id } = { ...clientIDs };
  const ga = {};
  if (client_id) {
    ga.client_id = client_id;
  }
  // se incluye session_id solo si existe client_id y tiene formato correcto
  if (session_id && client_id) {
    const gaRegex = /^\d+\.\d+$/;
    if (gaRegex.test(client_id)) {
      ga.session_id = session_id;
    }
  }
  let gaIds = "";
  if (Object.keys(ga).length > 0) {
    gaIds = JSON.stringify(ga);
  }
  return gaIds;
};

export const getReCaptchaToken = ({ action = "default" }) => {
  return new Promise((resolve) => {
    if (typeof window === "undefined" || !window.grecaptcha) {
      resolve(null);
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(RECAPTCHA_KEY, { action }).then((token) => {
        resolve(token);
      });
    });
  });
};

export const normalizeErrorInfo = (error, service, contextApi) => {
  const errorInfo = { ...webServiceErrorHandler[service] };
  try {
    const { handlingCode } = { ...errorInfo };
    const { status: errorCode } = { ...error };
    errorInfo.handlingCode = handlingCode[errorCode] || handlingCode.default;
    return errorInfo;
  } catch (e) {
    reportJSError(e, "normalizeErrorInfo", "utils/saga-utils", contextApi);
    return { ...errorInfo, handlingCode: -1 };
  }
};

export const reportJSError = (error, processName, filePath, context) => {
  try {
    if (error instanceof Error) {
      const sonda = new FrontSonda({
        processName,
        filePath,
        context,
      });
      sonda.errorMessage({ error });
    }
  } catch (e) {
    // Nothing to do
  }
};
